import Typography from '@mui/material/Typography';
import Box from '@mui/system/Box';
import { FC, PropsWithChildren } from 'react';

function EmptyState({ className: _, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <Box
      sx={{
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        width: '100%',
        padding: 2,
      }}
      {...props}
    />
  );
}

interface EmptyStateImageProps {
  src: string;
  alt: string;
}

const Image: FC<EmptyStateImageProps> = ({ src, alt }) => (
  <img
    src={src}
    alt={alt}
    style={{
      width: '100%',
      maxWidth: '350px',
    }}
  />
);

const PrimaryText: FC<PropsWithChildren<unknown>> = ({ children }) => (
  <Typography
    variant="h1"
    textAlign="center"
    fontSize={32}
    fontWeight={500}
    sx={{
      py: 2,
    }}
  >
    {children}
  </Typography>
);

const SecondaryText: FC<PropsWithChildren<unknown>> = ({ children }) => (
  <Typography variant="body2" textAlign="center">
    {children}
  </Typography>
);

EmptyState.Image = Image;
EmptyState.PrimaryText = PrimaryText;
EmptyState.SecondaryText = SecondaryText;

export { EmptyState };
